import React from 'react';
import PropTypes from 'prop-types';

const CmsColumn = ({
  blocks,
  groupTheme,
  parentClassName,
  ScrollIndexVertical,
  CmsComponents,
}) =>
  blocks.map(block => (
    <div className={parentClassName} key={block.id}>
      <CmsComponents
        data={{
          ...block,
          meta: { ...block.meta, container: 'full' },
          noMargin: true,
          groupTheme,
        }}
        key={`cmscolumn-${block.id}`}
        name={block.name}
        scrollIndex={ScrollIndexVertical}
      />
    </div>
  ));

CmsColumn.propTypes = {
  CmsComponents: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default CmsColumn;
